<template>
  <div class="feedback-result ">
    <div class="animation-wapper" >
      <lottie ref="animataion" :options="showGif"  v-on:animCreated="handleAnimation"/>
    </div>
    <h2>反馈已提交</h2>
    <div class="info">
      <p>感谢您的反馈，平台将在2个工作日内回电联系您，请您保持手机畅通。</p>
      <p>您也可再次致电 <span class="danger">400-010-0008</span> 咨询，或关注天美贷微信公众号联系在线客服咨询。</p>
    </div>
    <nd-button class="btn" theme="line" @click="handleAgin">再次反馈</nd-button>
  </div>
</template>

<script>
import Lottie from 'vue-lottie'
import { success } from '@/assets/json/index'
export default {
  data () {
    return {
      showGif: { animationData: success, loop: false }
    }
  },
  components: {
    Lottie
  },
  created () {
    this.$bus.$emit('ready')
  },
  methods: {
    handleAnimation (anim) {
      this.anim = anim
    },
    handleAgin () {
      localStorage.removeItem('feedbackDate')
      this.$router.push({ path: '/feedback/index' })  
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.feedback-result {
  display: flex;
  padding:100px 40px;
  flex-direction: column;
  align-items: center;
  gap:20px;
  .animation-wapper {
    width: 160px;
  }
  .danger {
    color: #FF4633
  }
  .info {
    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #333333;
      margin-top: 20px;
    }
    padding-bottom: 40px;
  }
  .btn {
    width: 320px;
  }
}
</style>